import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import moment from 'jalali-moment';
import { ColorConverterService } from '@digipay/ng-lib-color-converter';
import * as i1 from '@angular/platform-browser';
import { convertNonEnglishDigits, currencyFormat } from '@digipay/strings';
let FormattedCellNumberPipe = /*#__PURE__*/(() => {
  class FormattedCellNumberPipe {
    transform(value, args) {
      if (!value) {
        return '';
      }
      if (typeof value === 'string') {
        return value.replace(/^(\d{4})(\d{3})(\d{4})$/ig, '$1 $2 $3');
      }
      return null;
    }
    static {
      this.ɵfac = function FormattedCellNumberPipe_Factory(t) {
        return new (t || FormattedCellNumberPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "formattedCellNumber",
        type: FormattedCellNumberPipe,
        pure: true
      });
    }
  }
  return FormattedCellNumberPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SeparateThousandsPipe = /*#__PURE__*/(() => {
  class SeparateThousandsPipe {
    priceFormat(n, separator = '٬') {
      if (typeof n !== 'string') {
        n = parseInt(n);
      }
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }
    transform(value, args) {
      const n = parseInt(value, 10);
      if (isNaN(n) || typeof value === 'undefined' || value === '') {
        return '';
      }
      const options = {
        sep: '٬'
      };
      return this.priceFormat(value, options.sep);
    }
    static {
      this.ɵfac = function SeparateThousandsPipe_Factory(t) {
        return new (t || SeparateThousandsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "thousands",
        type: SeparateThousandsPipe,
        pure: true
      });
    }
  }
  return SeparateThousandsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let JalaliDatePipe = /*#__PURE__*/(() => {
  class JalaliDatePipe {
    transform(value, args) {
      let format = 'jYYYY/jM/jD';
      if (args) {
        format = args;
      }
      if (value) {
        return moment(value).locale('fa').format(format);
      }
      return null;
    }
    static {
      this.ɵfac = function JalaliDatePipe_Factory(t) {
        return new (t || JalaliDatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "jalaliDate",
        type: JalaliDatePipe,
        pure: true
      });
    }
  }
  return JalaliDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RgbColorPipe = /*#__PURE__*/(() => {
  class RgbColorPipe {
    transform(value, args) {
      let alpha = 1;
      if (args) {
        alpha = parseFloat(args);
      }
      return ColorConverterService.convertDecimalToRgba(value, alpha);
    }
    static {
      this.ɵfac = function RgbColorPipe_Factory(t) {
        return new (t || RgbColorPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rgbColor",
        type: RgbColorPipe,
        pure: true
      });
    }
  }
  return RgbColorPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SafeHtmlPipe = /*#__PURE__*/(() => {
  class SafeHtmlPipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(value, args) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    static {
      this.ɵfac = function SafeHtmlPipe_Factory(t) {
        return new (t || SafeHtmlPipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "safeHtml",
        type: SafeHtmlPipe,
        pure: true
      });
    }
  }
  return SafeHtmlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardNumberPipe = /*#__PURE__*/(() => {
  class CardNumberPipe {
    transform(value = '', separator = ' ', args) {
      if (!value) {
        return '';
      }
      value = convertNonEnglishDigits(value).replace(/[^\d]/g, '');
      if (value.length < 4 || value.length > 16) {
        return value;
      }
      let formattedValue = '';
      while (value.length) {
        formattedValue += value.substring(0, 4);
        value = value.substring(4);
        if (value.length) {
          if (separator == 'xa0') {
            formattedValue += '\xa0\xa0';
          } else {
            formattedValue += separator;
          }
        }
      }
      return formattedValue;
    }
    static {
      this.ɵfac = function CardNumberPipe_Factory(t) {
        return new (t || CardNumberPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cardNumber",
        type: CardNumberPipe,
        pure: true
      });
    }
  }
  return CardNumberPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PersianDatePipe = /*#__PURE__*/(() => {
  class PersianDatePipe {
    constructor() {
      this.weekDayNames = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه'];
      this.monthNames = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
      this.strWeekDay = null;
      this.strMonth = null;
      this.day = null;
      this.month = null;
      this.year = null;
      this.currentYear = null;
      this.ld = null;
      this.farsiDate = null;
      this.today = new Date();
      this.gregorianYear = null;
      this.currentGregorianYear = null;
      this.gregorianMonth = null;
      this.gregorianDate = null;
      this.WeekDay = null;
      this.buf1 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
      this.buf2 = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
    }
    transform(value) {
      this.today = value;
      this.currentGregorianYear = new Date().getFullYear();
      this.gregorianYear = this.today.getFullYear();
      this.gregorianMonth = this.today.getMonth() + 1;
      this.gregorianDate = this.today.getDate();
      this.WeekDay = this.today.getDay();
      this.toPersian();
      const returnValue = this.day + ' ' + this.strMonth + ' ' + this.year;
      return returnValue;
    }
    toPersian() {
      if (this.gregorianYear % 4 !== 0) {
        this.farsiDate = this.func1();
      } else {
        this.farsiDate = this.func2();
      }
      this.strMonth = this.monthNames[Math.floor(this.month - 1)];
      this.strWeekDay = this.weekDayNames[this.WeekDay];
    }
    func1() {
      this.day = this.buf1[this.gregorianMonth - 1] + this.gregorianDate;
      if (this.day > 79) {
        this.day = this.day - 79;
        if (this.day <= 186) {
          const day2 = this.day;
          this.month = day2 / 31 + 1;
          this.day = day2 % 31;
          if (day2 % 31 === 0) {
            this.month--;
            this.day = 31;
          }
          this.year = this.gregorianYear - 621;
        } else {
          const day2 = this.day - 186;
          this.month = day2 / 30 + 7;
          this.day = day2 % 30;
          if (day2 % 30 === 0) {
            this.month = day2 / 30 + 6;
            this.day = 30;
          }
          this.year = this.gregorianYear - 621;
        }
      } else {
        this.ld = this.gregorianYear > 1996 && this.gregorianYear % 4 === 1 ? 11 : 10;
        const day2 = this.day + this.ld;
        this.month = day2 / 30 + 10;
        this.day = day2 % 30;
        if (day2 % 30 === 0) {
          this.month--;
          this.day = 30;
        }
        this.year = this.gregorianYear - 622;
      }
      const fullDate = this.day + '/' + Math.floor(this.month) + '/' + this.year;
      return fullDate;
    }
    func2() {
      this.day = this.buf2[this.gregorianMonth - 1] + this.gregorianDate;
      this.ld = this.gregorianYear >= 1996 ? 79 : 80;
      if (this.day > this.ld) {
        this.day = this.day - this.ld;
        if (this.day <= 186) {
          const day2 = this.day;
          this.month = day2 / 31 + 1;
          this.day = day2 % 31;
          if (day2 % 31 === 0) {
            this.month--;
            this.day = 31;
          }
          this.year = this.gregorianYear - 621;
        } else {
          const day2 = this.day - 186;
          this.month = day2 / 30 + 7;
          this.day = day2 % 30;
          if (day2 % 30 === 0) {
            this.month--;
            this.day = 30;
          }
          this.year = this.gregorianYear - 621;
        }
        const fullDate = this.day + '/' + Math.floor(this.month) + '/' + this.year;
        return fullDate;
      } else {
        const day2 = this.day + 10;
        this.month = day2 / 30 + 10;
        this.day = day2 % 30;
        if (day2 % 30 === 0) {
          this.month--;
          this.day = 30;
        }
        this.year = this.gregorianYear - 622;
      }
    }
    static {
      this.ɵfac = function PersianDatePipe_Factory(t) {
        return new (t || PersianDatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "persianDate",
        type: PersianDatePipe,
        pure: true
      });
    }
  }
  return PersianDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RelativeDatePipe = /*#__PURE__*/(() => {
  class RelativeDatePipe {
    constructor(persianDate) {
      this.persianDate = persianDate;
    }
    transform(value, args) {
      if (!value || isNaN(value)) {
        return '';
      }
      const date = new Date(value);
      const dateNow = new Date();
      const differenceInTime = dateNow.getTime() - date.getTime();
      const absoluteDifferenceInTime = Math.abs(differenceInTime);
      if (absoluteDifferenceInTime <= 60000) {
        return differenceInTime ? 'لحظاتی دیگر' : 'لحظاتی پیش';
      } else if (absoluteDifferenceInTime <= 3600000) {
        const differenceInMins = Math.floor(absoluteDifferenceInTime / 60000);
        return differenceInTime < 0 ? `${differenceInMins} دقیقه آینده` : `${differenceInMins} دقیقه پیش`;
      } else if (absoluteDifferenceInTime <= 86400000) {
        const differenceInHours = Math.floor(absoluteDifferenceInTime / (1000 * 3600));
        return differenceInTime < 0 ? `${differenceInHours} ساعت آینده` : `${differenceInHours} ساعت پیش`;
      } else {
        const DifferenceInDays = Math.floor(absoluteDifferenceInTime / (1000 * 3600 * 24));
        if (DifferenceInDays === 0) {
          return 'امروز';
        } else if (DifferenceInDays === 1) {
          return differenceInTime < 0 ? 'فردا' : 'دیروز';
        } else if (DifferenceInDays < 7) {
          return differenceInTime < 0 ? `${DifferenceInDays} روز آینده` : `${DifferenceInDays} روز پیش`;
        } else if (DifferenceInDays == 7) {
          return differenceInTime < 0 ? `هفته آینده` : `هفته پیش`;
        } else {
          const currentYear = this.persianDate.transform(dateNow).split(' ')[2];
          return this.persianDate.transform(date).replace(` ${currentYear}`, '');
        }
      }
    }
    static {
      this.ɵfac = function RelativeDatePipe_Factory(t) {
        return new (t || RelativeDatePipe)(i0.ɵɵdirectiveInject(PersianDatePipe, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "relativeDate",
        type: RelativeDatePipe,
        pure: true
      });
    }
  }
  return RelativeDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SummarizerPipe = /*#__PURE__*/(() => {
  class SummarizerPipe {
    transform(value, ...args) {
      let length = 50;
      value = String(value);
      if (args.length !== 0) {
        length = args[0];
      }
      if (value.length <= length) {
        return value;
      } else {
        return value.substring(0, length - 3) + '...';
      }
    }
    static {
      this.ɵfac = function SummarizerPipe_Factory(t) {
        return new (t || SummarizerPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "summarize",
        type: SummarizerPipe,
        pure: true
      });
    }
  }
  return SummarizerPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StripTagsPipe = /*#__PURE__*/(() => {
  class StripTagsPipe {
    transform(value, ...args) {
      let replaceWith = '';
      if (args.length !== 0) {
        replaceWith = args[0];
      }
      return value.replace(/<[^>]*>/g, replaceWith);
    }
    static {
      this.ɵfac = function StripTagsPipe_Factory(t) {
        return new (t || StripTagsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "stripTags",
        type: StripTagsPipe,
        pure: true
      });
    }
  }
  return StripTagsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CleanerPipe = /*#__PURE__*/(() => {
  class CleanerPipe {
    transform(value) {
      value = value.replace(/\r?\n/g, ' ');
      return value.replace(/\s{2,}/g, ' ');
    }
    static {
      this.ɵfac = function CleanerPipe_Factory(t) {
        return new (t || CleanerPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cleaner",
        type: CleanerPipe,
        pure: true
      });
    }
  }
  return CleanerPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IranianRialsPipe = /*#__PURE__*/(() => {
  class IranianRialsPipe {
    transform(value, args) {
      const number = parseInt(value);
      if (isNaN(number) || typeof value === 'undefined' || value === '') {
        return '';
      }
      let options = {
        hideRial: false,
        sep: '٬'
      };
      if (args) {
        // separate options by | character
        args = args.split('|');
        // set hideRial to true if it is present
        // in the array
        if (args.indexOf('hideRial') >= 0) {
          options['hideRial'] = true;
        }
        // make key:value pairs for
        // the passed options
        args.forEach(arg => {
          if (arg.indexOf(':') > 0) {
            // split by colon to separate
            // the keys from the values
            let keyValueSplit = arg.split(':');
            options[keyValueSplit[0]] = keyValueSplit[1];
          }
        });
      }
      let rialText = options.hideRial ? '' : ' ریال';
      return currencyFormat(value, options.sep) + rialText;
    }
    static {
      this.ɵfac = function IranianRialsPipe_Factory(t) {
        return new (t || IranianRialsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "IRR",
        type: IranianRialsPipe,
        pure: true
      });
    }
  }
  return IranianRialsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MaskCardNumberPipe = /*#__PURE__*/(() => {
  class MaskCardNumberPipe {
    transform(cardNumber, isMasked = false, separator = ' ') {
      if (!isMasked) return this.insertSeparator(cardNumber, separator);
      if (!cardNumber) return '';
      // remove all spaces
      const cleaned = cardNumber.replace(/\s/g, '');
      let formattedValue = '';
      for (let i = 0; i < cleaned.length; i++) {
        if (i > 5 && i < 12) {
          formattedValue += '*';
        } else {
          formattedValue += cleaned[i];
        }
      }
      return this.insertSeparator(formattedValue, separator);
    }
    insertSeparator(text, separator = ' ', chunkSize = 4) {
      if (!text) return '';
      const regex = new RegExp(`.{1,${chunkSize}}`, 'g');
      return text.match(regex).join(separator);
    }
    static {
      this.ɵfac = function MaskCardNumberPipe_Factory(t) {
        return new (t || MaskCardNumberPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "maskCardNumber",
        type: MaskCardNumberPipe,
        pure: true
      });
    }
  }
  return MaskCardNumberPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PipesModule = /*#__PURE__*/(() => {
  class PipesModule {
    static {
      this.ɵfac = function PipesModule_Factory(t) {
        return new (t || PipesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PipesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [PersianDatePipe],
        imports: [CommonModule]
      });
    }
  }
  return PipesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of pipes
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardNumberPipe, CleanerPipe, FormattedCellNumberPipe, IranianRialsPipe, JalaliDatePipe, MaskCardNumberPipe, PersianDatePipe, PipesModule, RelativeDatePipe, RgbColorPipe, SafeHtmlPipe, SeparateThousandsPipe, StripTagsPipe, SummarizerPipe };
